module.exports = __webpack_public_path__ + "static/media/abroad.3ca9fb0e.svg";